import React, { useState } from 'react';
import { Form, Modal, message } from 'antd';
import { TextService } from '../../../Services/TextService';
import { IntegrationService } from '../../../Services/IntegrationService';
import { WebApiMemberDtoExternalPaymentDto } from '../../../Repository/eventbookyapi';

interface RefundModalProps {
    payment: WebApiMemberDtoExternalPaymentDto | null;
    open: boolean;
    onClose: () => void;
    onRefunded: () => void;
}

const RefundModal = ({ payment, open, onClose, onRefunded }: RefundModalProps) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const GetText = TextService.GetText;

    const handleRefund = async () => {
        try {
            const values = await form.validateFields();
            if (!payment?.paymentLinkId) return;

            setLoading(true);
            await IntegrationService.RefundPaymentLink({
                paymentLinkId: payment.paymentLinkId,
                amount: payment.totalAmount! * 100,
                description: values.description,
                message: values.message,
            });

            message.success(GetText("Refund_Success"));
            onClose();
            onRefunded();
        } catch {
            message.error(GetText("Refund_Error"));
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            open={open}
            title={GetText("Refund_ModalTitle")}
            okText={GetText("Refund_Confirm")}
            cancelText={GetText("EditMember_ModalClose")}
            onOk={handleRefund}
            onCancel={onClose}
            confirmLoading={loading}
        >
            {payment && (
                <div style={{ marginBottom: '16px' }}>
                    <p><strong>{GetText("Refund_Amount")}:</strong> {payment.totalAmount} kr</p>
                </div>
            )}
            <Form form={form} layout="vertical">
                <Form.Item
                    name="description"
                    label={GetText("Refund_Description")}
                    rules={[{ required: true, message: GetText("Refund_DescriptionRequired") }]}
                >
                    <input className="ant-input" placeholder={GetText("Refund_DescriptionPlaceholder")} />
                </Form.Item>
                <Form.Item
                    name="message"
                    label={GetText("Refund_Message")}
                    rules={[{ required: true, message: GetText("Refund_MessageRequired") }]}
                >
                    <input className="ant-input" placeholder={GetText("Refund_MessagePlaceholder")} />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default RefundModal;
